export default {
  PRIMARY: '#00b7eb',
  DANGER: '#bb2124',
  SUCCESS: '#22bb33',
  WARNING: '#f0ad4e',
  INFO: '#5bc0de',
  GRAY999: '#999999',
  DEFAULT: '#292b2c'
};
